import { Color } from 'theme';

// You can use this Codepen https://codepen.io/sosuke/pen/Pjoqqp
// to convert HEX colors to filter
const filters: Record<Color, string> = {
  black: '',
  white: 'invert(100%)',
  fog: 'invert(99%) sepia(3%) saturate(177%) hue-rotate(222deg) brightness(114%) contrast(97%)',
  platinum:
    'invert(100%) sepia(1%) saturate(5051%) hue-rotate(141deg) brightness(119%) contrast(93%)',
  lightGrey:
    'invert(100%) sepia(71%) saturate(938%) hue-rotate(161deg) brightness(121%) contrast(92%)',
  offWhite:
    'invert(100%) sepia(17%) saturate(244%) hue-rotate(227deg) brightness(113%) contrast(89%)',
  aluminum:
    'invert(99%) sepia(0%) saturate(7210%) hue-rotate(175deg) brightness(114%) contrast(80%)',
  silver:
    'invert(87%) sepia(7%) saturate(147%) hue-rotate(169deg) brightness(95%) contrast(82%)',
  coolGrey:
    'invert(73%) sepia(4%) saturate(318%) hue-rotate(173deg) brightness(98%) contrast(91%)',
  middleGrey:
    'invert(47%) sepia(0%) saturate(8%) hue-rotate(198deg) brightness(100%) contrast(88%)',
  battleshipGrey:
    'invert(45%) sepia(7%) saturate(142%) hue-rotate(169deg) brightness(96%) contrast(80%)',
  greyishBrown:
    'invert(24%) sepia(0%) saturate(1%) hue-rotate(267deg) brightness(102%) contrast(85%)',
  charcoalGrey:
    'invert(13%) sepia(36%) saturate(0%) hue-rotate(243deg) brightness(88%) contrast(95%)',
  waterBlue:
    'invert(29%) sepia(100%) saturate(1392%) hue-rotate(193deg) brightness(94%) contrast(94%)',
  niceBlue:
    'invert(18%) sepia(92%) saturate(3206%) hue-rotate(203deg) brightness(89%) contrast(88%)',
  turtleGreen:
    'invert(61%) sepia(56%) saturate(425%) hue-rotate(62deg) brightness(95%) contrast(91%)',
  marigold:
    'invert(80%) sepia(63%) saturate(1482%) hue-rotate(358deg) brightness(97%) contrast(100%)',
  scarlet:
    'invert(18%) sepia(47%) saturate(5574%) hue-rotate(341deg) brightness(83%) contrast(119%)',
  lightRed:
    'invert(75%) sepia(4%) saturate(2742%) hue-rotate(313deg) brightness(117%) contrast(100%)',
  steelGrey:
    'invert(43%) sepia(12%) saturate(0%) hue-rotate(183deg) brightness(95%) contrast(77%)',
  mediumNavy:
    'invert(15%) sepia(35%) saturate(7138%) hue-rotate(202deg) brightness(92%) contrast(102%)',
  skyBlue:
    'invert(48%) sepia(67%) saturate(717%) hue-rotate(169deg) brightness(90%) contrast(105%)',
  babyBlue:
    'invert(66%) sepia(30%) saturate(894%) hue-rotate(164deg) brightness(103%) contrast(89%)',
  lightBlue:
    'invert(87%) sepia(18%) saturate(843%) hue-rotate(172deg) brightness(102%) contrast(101%)',
  softBlue:
    'invert(83%) sepia(17%) saturate(416%) hue-rotate(192deg) brightness(111%) contrast(102%)',
  lemon:
    'invert(85%) sepia(50%) saturate(680%) hue-rotate(8deg) brightness(109%) contrast(98%)',
  poppy:
    'invert(32%) sepia(74%) saturate(1828%) hue-rotate(333deg) brightness(98%) contrast(92%)',
  brick:
    'invert(21%) sepia(60%) saturate(7439%) hue-rotate(343deg) brightness(67%) contrast(118%)',
  fuchsia:
    'invert(18%) sepia(88%) saturate(4821%) hue-rotate(275deg) brightness(92%) contrast(126%)',
  tagLemonGreen:
    'invert(76%) sepia(99%) saturate(290%) hue-rotate(49deg) brightness(92%) contrast(99%)',
  hoverBlue:
    'invert(20%) sepia(52%) saturate(3751%) hue-rotate(208deg) brightness(93%) contrast(122%)',
};

export function cssFilterForColor(color: Color): string | undefined {
  return filters[color];
}
